import { type LucideIcon } from 'lucide-react';
import { formatNumber } from '@employer-on-record/shared';
import { cn } from '@/lib/utils';

type Tone = 'blue' | 'green' | 'amber' | 'red' | 'violet';

interface Props {
	label: string;
	value: string | number;
	delta?: string;
	icon: LucideIcon;
	tone?: Tone;
}

export function StatCard({ label, value, delta, icon: Icon, tone = 'blue' }: Props) {
	const display = typeof value === 'number' ? formatNumber(value) : value;
	return (
		<div className="flex items-center gap-3.5 rounded-lg border bg-card px-5 py-4">
			<div className={cn('stat-icon h-10 w-10', `tone-${tone}`)}>
				<Icon className="h-[18px] w-[18px]" />
			</div>
			<div className="flex-1">
				<div className="text-xs text-muted-foreground mb-0.5">{label}</div>
				<div className="text-[22px] font-bold leading-tight tracking-tight tabular">{display}</div>
				{delta && <div className="text-[11px] mt-1 text-muted-foreground">{delta}</div>}
			</div>
		</div>
	);
}
